import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const DialogOpenCpanel = (props) => {

    //const openDialog = props.openDialog;
    const openDialog = props.openDialog;
    const titleDialog = props.titleDialog;
    const contentDialog = props.contentDialog;
    const styleDialog = props.styleDialog;
    const {t} = useTranslation();

    const handleCloseDialog = () => {
        //setOpenDialog(false);
        //navigate('/clientarea/account/', { replace: true });
        props.actionDialog(false);
    };

    return (
        <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle variant="dialogTitle-nk" id="alert-dialog-title" color={styleDialog}>
                {titleDialog}
            </DialogTitle>
            <DialogContent>
                <Typography color={styleDialog}>{contentDialog}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog} autoFocus variant='outlined' size="small">
                    {t('understood')}
                </Button>
            </DialogActions>

        </Dialog>
    );
}

export default DialogOpenCpanel;